import React from 'react';
import { Image as BaseImage, StyleSheet } from 'react-native';
import { Image as ExpoImage } from 'expo-image';

import { IS_WEB } from '../../lib/appConstants';

const Image = ({ source, ...props }: { source: any; [key: string]: any }) => {
  if (!IS_WEB && source && source.uri) {
    const { style, resizeMode, ...rest } = props;
    const flatStyle = style ? StyleSheet.flatten(style) : {};
    const { tintColor, ...imageStyle } = flatStyle as any;
    return (
      <ExpoImage
        {...rest}
        style={imageStyle}
        tintColor={tintColor}
        source={source.uri}
        contentFit={resizeMode || 'cover'}
        cachePolicy="disk"
      />
    );
  }
  return <BaseImage {...props} source={source} />;
};

export default Image;
